import { View3dGlobal, webcadDefines, WebCadItemManager, isMat, ItemType, ThreeView, w3dItemInfo, WebCadRenderer } from "../index";
import { defines, geoUtils, matUtils } from "../../base";
import * as marietta from "../../..";
import * as marietta3d from "../../../../marietta3d";
import * as THREE from "three";
import { SceneExtrasMaterial } from "../sceneExtrasMaterial";
import { MaterialSet } from './MaterialSet'
import { Material } from './Material'
import { ObjectType } from '../ObjectType';
import { ExtrasType } from "../WebCadDefines";

type USerData = { [key: string]: any };

/* MaterialManager
 * WebCAD用マテリアル管理.
 */
export class MaterialManager {
    private _instance: MaterialSet;
    public _partsMaterials: MaterialSet | any;

    public get me(): MaterialSet { return this._instance; }
    public set me(i: MaterialSet) { this._instance = i; }

    public set opeMode(mode: defines.OpeMode) { /* do nothing */ }

    // 屋根のマテリアルリスト
    public _roofMaterial: any = {};
    public _hanaMaterial: THREE.MeshStandardMaterial;
    public _muneMaterial: THREE.MeshStandardMaterial;

    // 外壁のマテリアルリスト
    public _wallMaterials: any = {};
    public _wallKosiMaterials: any = {};

    // 幕板、窓枠、ティンバー
    public _makuitaMaterial: THREE.MeshStandardMaterial;
    public _timberMaterial: THREE.MeshStandardMaterial;

    // 内壁・床のマテリアルリスト
    public _inWallMaterial: THREE.MeshStandardMaterial;
    public _sagariMaterial: THREE.MeshStandardMaterial;
    public _ceilingMaterial: THREE.MeshStandardMaterial;
    public _floorMaterial: THREE.MeshStandardMaterial;
    public _stairMaterial: THREE.MeshStandardMaterial;

    public _girderMaterial: THREE.MeshStandardMaterial;
    public _habakiMaterial: THREE.MeshStandardMaterial;

    // 建具のマテリアルリスト
    public _entryDoorMaterial: THREE.MeshStandardMaterial;
    public _doorMaterial: THREE.MeshStandardMaterial;
    public _windowMaterial: THREE.MeshStandardMaterial;
    public _curtainMaterial: THREE.MeshStandardMaterial;
    public _garageMaterial: THREE.MeshStandardMaterial;

    // スタイル割り当て情報
    public _materialPref: any;

    constructor() {
        this.me = new MaterialSet(View3dGlobal.shared.tex3dDir);
    }
    /* reset
     * データのリセット.
     */
    public reset(options: defines.Options) {
        if (options.is(webcadDefines.WebCadResetOptions.resetPartMaterials, true)) {
            this.me.reset();
            this._partsMaterials = undefined;
        }

        this._roofMaterial = {};
        this._hanaMaterial = undefined;
        this._muneMaterial = undefined;

        this._wallMaterials = {};
        this._wallKosiMaterials = {};

        this._makuitaMaterial = undefined;
        this._timberMaterial = undefined;

        this._inWallMaterial = undefined;
        this._sagariMaterial = undefined;
        this._ceilingMaterial = undefined;
        this._floorMaterial = undefined;
        this._stairMaterial = undefined;
        this._girderMaterial = undefined;

        this._habakiMaterial = undefined;

        this._entryDoorMaterial = undefined;
        this._doorMaterial = undefined;
        this._windowMaterial = undefined;
        this._curtainMaterial = undefined;
        this._garageMaterial = undefined;

        this._materialPref = {};
    }

    /* setupMaterials
     * セットアップ.
     */
    public setupMaterials(autoMain: marietta3d.manager.AutoMain) {
        if (this._partsMaterials == undefined) {
            this.me.getMaterialData(autoMain.autoData.Model);
            this._partsMaterials = this.me.materials();
        }
    }

    public loadMaterialPrefs(userData: USerData) {
        const materials = userData.material;

        if (materials == null) {
            console.log("Materials NOT FOUND!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!");
            return;
        }

        materials.forEach((material) => {
           this._materialPref[material.name] = material.value;
        });
    }

    // Material 名称の変換.
    public remapMaterialNames(obj3d: THREE.Object3D, attr: string) {
        // 子形状を走査
        for (let i = 0; i < obj3d.children.length; i++) {
            // ポリゴンメッシュのみを処理.
            if (!((<THREE.Mesh>obj3d.children[i]).isMesh)) {
                if (obj3d.children[i].children.length > 0) {
                    this.remapMaterialNames((obj3d.children[i] as THREE.Object3D), attr);
                }
                continue;
            }
            const mesh: THREE.Mesh = <THREE.Mesh>(obj3d.children[i]);
            if (mesh.material != undefined) {
                this.remapMatNames(mesh, attr);
            }
        }
    }

    private remapMatNames(mesh: THREE.Mesh, attr: string) {
        if (!this.remapMatNameMulti(mesh, attr))
            this.remapMatName(mesh, -1, attr);
    }

    private remapMatNameMulti(mesh: THREE.Mesh, attr: string): boolean {
        if (!(Array.isArray(mesh.material))) return false;
        const multiMaterial = mesh.material;
        for (let i = 0; i < multiMaterial.length; i++) {
            this.remapMatName(mesh, i, attr);
        }
        return true;
    }

    private remapMatName(mesh: THREE.Mesh, multiIndex: number, attr: string): boolean {
        if (this._partsMaterials == undefined) return false;
        const material = this.getSingleMaterial(mesh, multiIndex);
        const reName = this.mateNameConvert(material.name, attr)
        if (reName != "") material.name = reName;
    }

    private mateNameConvert(original: string, attr: string): string {
        let name = "";
        if (original.match(/(.*)(\-fx)/)) original = original.replace(/(.*)(\-fx)/, '$1');
        if (attr.match(/^ent/)) {
            switch (original) {
                case "Material-gakubuti": name = "ent-gakubuti"; break;
                case "Material-glass": name = "ent-glass"; break;
                case "Material-sash": name = "ent-body"; break;
                case "Material-curtain": name = "ent-curtain"; break;
                case "Material-door": name = "ent-body"; break;
                case "Material-kanamono": name = "ent-kanamono"; break;
                default:
                    name = original; break;
            }
        } else if (attr.match(/^win/)) {
            switch (original) {
                case "Material-gakubuti": name = "sash-gakubuti"; break;
                case "Material-glass": name = "sash-glass"; break;
                case "Material-sash": name = "sash-body"; break;
                case "Material-curtain": name = "sash-curtain"; break;
                case "Material-door": name = "sash-body"; break;
                case "Material-kanamono": name = "sash-kanamono"; break;
                default:
                    name = original; break;
            }
        } else if (attr.match(/^sash/)) {
            switch (original) {
                case "Material-gakubuti": name = "sash-gakubuti"; break;
                case "Material-glass": name = "sash-glass"; break;
                case "Material-sash": name = "sash-body"; break;
                case "Material-curtain": name = "sash-curtain"; break;
                case "Material-door": name = "sash-body"; break;
                case "Material-kanamono": name = "sash-kanamono"; break;
                default:
                    name = original; break;
            }
        } else if (attr.match(/^door/) || attr.match(/^toilet/)) {
            switch (original) {
                case "Material-gakubuti": name = "door-gakubuti"; break;
                case "Material-glass": name = "door-glass"; break;
                case "Material-sash": name = "door-body"; break;
                case "Material-curtain": name = "door-curtain"; break;
                case "Material-door": name = "door-body"; break;
                case "Material-kanamono": name = "door-kanamono"; break;
                default:
                    name = original; break;
            }
        } else if (attr.match(/^shutter/)) {
            switch (original) {
                case "Material-gakubuti": name = "shutter-gakubuti"; break;
                case "Material-glass": name = "shutter-glass"; break;
                case "Material-sash": name = "shutter-body"; break;
                case "Material-curtain": name = "shutter-curtain"; break;
                case "Material-door": name = "shutter-body"; break;
                case "Material-kanamono": name = "shutter-kanamono"; break;
                default:
                    name = original; break;
            }
        }
        return name;
    }

    /* applyMaterials
     * マテリアルを家に適用する.
     */
    public applyMaterials(items: WebCadItemManager) {
        if (items.houseObjects == undefined) return;

        this.setMaterial(items.houseObjects);
        this.setMaterial(items.setbackObjects.objects);
    }

    /* applyObjectMaterial
     * マテリアルをオブジェクトに適用する.
     */
    public applyObjectMaterial(obj3d: THREE.Object3D, recursive: boolean) {
        for (let j = 0; j < obj3d.children.length; j++) {

            // ポリゴンメッシュのみを処理.
            // @ts-ignore
            if (!(obj3d.children[j].isMesh)) {
                //　再帰適用.
                if (recursive && (obj3d.children[j].children.length > 0)) {
                    this.applyObjectMaterial(obj3d.children[j], recursive);
                }
                continue;
            }
            const mesh: THREE.Mesh = <THREE.Mesh>(obj3d.children[j]);
            // マテリアル設定のあるもののみを処理.
            if (mesh.material != undefined) {
                // メッシュにマテリアルを適用.
                this.applyMaterial(mesh);
            }
        }
    }

    // 一致するテクスチャーの取得
    private getTexture = (mesh: THREE.Object3D, material: string) => {

        const texture = (textureList) => {
            return textureList.find(textureObj => {
                if (textureObj.name == material) return true;
            });
        }

        const textures = [
            [this._partsMaterials.clothTexes, ObjectType.isCeiling_(mesh) || ObjectType.isGirder(mesh) || ObjectType.isInnerWall(mesh) || ObjectType.isFallingWall(mesh)],
            [[...this._partsMaterials.floorTexes, ...this._partsMaterials.tatamiTexes], ObjectType.isFloor_(mesh) || ObjectType.isKamachi(mesh)],
            [this._partsMaterials.wallTexes, ObjectType.isOuterWall(mesh)]
        ];
        for(let i = 0; i < textures.length; i++) {
            const func = textures[i];
            const result = func[1];
            if (result) {
                return texture(func[0]);
            }
        }

        // // 天井と内壁のテクスチャー取得
        // if (ThreeView.get().selectManager.isCeiling_(mesh) || ThreeView.get().selectManager.isInnerWall(mesh)) {
        //     return this._partsMaterials.clothTexes.find(textureObj => {
        //         if (textureObj.name == material) return true;
        //     });
        // }
        // // 床のテクスチャー取得
        // if (ThreeView.get().selectManager.isFloor_(mesh)) {
        //     return this._partsMaterials.floorTexes.find(textureObj => {
        //         if (textureObj.name == material) return true;
        //     });
        // }
        // // 外壁のテクスチャー取得
        // if (ThreeView.get().selectManager.isOuterWall(mesh)) {
        //     return this._partsMaterials.wallTexes.find(textureObj => {
        //         if (textureObj.name == material) return true;
        //     });
        // }
        return undefined;
    }

    /* applyPointWall
     * ワンポイント壁/天井/床の適用
     */
    public applyPointTexture(items: WebCadItemManager) {
        if (items.houseObjects == undefined) return;
        if (!ThreeView.get().wcItemmgr.GltfExtras.individual) return;

        const wallPointTextureDatas: {guid: string, material: string}[] = [];

        const houseObjects = items.houseObjects;
        houseObjects.traverse((houseObject: THREE.Object3D) => {
            const mesh = <THREE.Mesh>houseObject;
            if (!mesh.isMesh) return;

            const object = ThreeView.get().wcItemmgr.GltfExtras.individual.find(obj => obj.node_id == mesh.name);
            if (object && object.material) {
                this.SetMaterialPointTexture(mesh, object.material);

                if (mesh.userData?.guid && mesh.userData?.guid != '' && mesh.userData.type === ExtrasType.KABE) {
                    if (wallPointTextureDatas.some((data) => data.guid === mesh.userData.guid)) return;
                    wallPointTextureDatas.push({guid: mesh.userData.guid, material: object.material});
                }
            }
        });

        const findObjectFromGUID = (guid: string): THREE.Object3D[] => {
            const objects: THREE.Object3D[] = [];
            houseObjects.traverse((object: THREE.Object3D) => {
                if (object.userData.guid === guid || object.userData.modelInfo && object.userData.modelInfo.uuid === guid) {
                    objects.push(object);
                }
            });
            console.log(`${guid} : 複数の形状で同じGUIDが割り当てられています。`);
            return objects;
        };

        // 開口があった際に2Dと3Dの頂点が一致していないため、ワンポイント壁が適用されない不具合が起きている
        // リストに情報を入れておいて、後で更新をかける STARTS_LIDAR-1171
        wallPointTextureDatas.forEach((data) => {
            const objects = findObjectFromGUID(data.guid);
            if (objects.length === 0) return;
            objects.forEach((obj) => {
                if (!(<THREE.Mesh>obj)?.isMesh) return;
                this.SetMaterialPointTexture(<THREE.Mesh>obj, data.material);
            });
        });
    }

    /** ワンポイント壁/床/天井のマテリアル適用 */
    private SetMaterialPointTexture(mesh: THREE.Mesh, materialImg: string) {
        const texture = this.getTexture(mesh, materialImg);

        if (!texture) return;
        const material = (<THREE.MeshStandardMaterial>mesh.material).clone();
        material.map = texture;
        material.color.setRGB(1.0, 1.0, 1.0, 'srgb');
        mesh.material = material;
        mesh.material.needsUpdate = true;
    }

    /* setMaterial
     * type:Meshであれば、マテリアルを適用
     */
    private setMaterial(items: THREE.Group){
        items.traverse((item) => {
            const obj = <THREE.Mesh>item;
            if (obj.isMesh) {
                this.applyMaterial(obj);
            }
        })
    }

    /* applyMaterial
     * オブジェクトにマテリアルを適用.
     */
    private applyMaterial(mesh: THREE.Mesh) {
        // マテリアルのクラスを変更しても対応できるように.
        if (!this.processMultiMaterial(mesh) &&
            !this.processMaterial(mesh, -1)) {
        }
    }

    /* processMultiMaterial
     * MultiMaterialの場合.
     */
    private processMultiMaterial(mesh: THREE.Mesh): boolean {
        if (!(Array.isArray(mesh.material))) return false;
        const multiMaterial = mesh.material;

        for (let i = 0; i < multiMaterial.length; i++) {
            if (!this.processMaterial(mesh, i)) {
                ;
            }
        }
        return true;
    }

    /* getSingleMaterial
     * Materialの取得.
     */
    private getSingleMaterial(mesh: THREE.Mesh, multiIndex: number): any {
        if (multiIndex >= 0) {
            const multiMaterial = mesh.material;
            return multiMaterial[multiIndex];
        }
        // @ts-ignore
        else if (mesh.material.type === "MeshLambertMaterial") {
            return <THREE.MeshLambertMaterial>(mesh.material);
        }
        // @ts-ignore
        else if (mesh.material.type === "MeshPhongMaterial") {
            return <THREE.MeshPhongMaterial>(mesh.material);
        }
        return <THREE.MeshBasicMaterial>(mesh.material);
    }

    /* copyMaterial
     * Materialのコピー.
     */
    private copyMaterial(mat: THREE.Material, mesh: THREE.Mesh, multiIndex: number, refer?: boolean) {
        if (mat == undefined) return;
        if (refer == undefined) refer = false;
        if (multiIndex >= 0) {
            const multiMaterial = mesh.material;
            geoUtils.disposeMaterial(multiMaterial[multiIndex]);

            if (refer) multiMaterial[multiIndex] = mat;
            else multiMaterial[multiIndex] = mat.clone();
        }
        else {
            if (refer) mesh.material = mat;
            else mesh.material = mat.clone();
        }
    }

    /* stripPartName
     * 設定名を取得.
     */
    private stripPartName(name: string): string {
        if (name.match(/(.*)(\.[0-9][0-9][0-9]$)/)) return name.replace(/(.*)(\.[0-9][0-9][0-9]$)/, "$1");
        return name.replace(/(^.*)(_[0-9][0-9])(-.*)/, "$1$3");
    }

    /* materialPref
     * Materialの設定を取得.
     */
    public materialPref(name: string, defName: string): string {
        const pref = this._materialPref[this.stripPartName(name)];
        if (pref == undefined) return defName;
        return pref;
    }

    /* getTexPrefIndex
     * texture のスタイル設定番号を取得.
     */
    public getTexPrefIndex(name: string, textures: THREE.Texture[], defIndex: number): number {
        const pref = this._materialPref[this.stripPartName(name)];
        if (pref != undefined) {
            for (let i = 0; i < textures.length; i++) {
                if (textures[i].name == pref) return i;
            }
        }
        return defIndex;
    }

    /* getMatPrefIndex
     * material のスタイル設定番号を取得.
     */
    private getMatPrefIndex(name: string, materials: Material[], defIndex: number): number {
        const _pref = this._materialPref[this.stripPartName(name)];
        if (_pref != undefined) {
            for (let i = 0; i < materials.length; i++) {
                if (materials[i].name == _pref) return i;
            }
        }
        return defIndex;
    }

    // -- 色質感設定 ---------------------------------------------------------------------------------------------

    // ガラス.
    private glassMaterial = (materialName: string, mesh: THREE.Mesh, multiIndex: number) => {
        const index = this.getMatPrefIndex(materialName, this._partsMaterials.glassMaterials, (materialName.match(/frosted/) ? 1 : 0));
        this.copyMaterial(this._partsMaterials.glassMaterials[index], mesh, multiIndex, true);
    }
    // 金物.
    private metalMaterial = (materialName: string, mesh: THREE.Mesh, multiIndex: number) => {
        this.copyMaterial(this._partsMaterials.metal, mesh, multiIndex, true);
    }
    // 壁影.
    private wallShadowMaterial = (materialName: string, mesh: THREE.Mesh, multiIndex: number) => {
        let names = materialName.match(/shadow_wall_\d{2}/);
        if ((names.length > 0) && (this._partsMaterials.shadowMaterials[names[0]] != undefined)) {
            if ((this._partsMaterials.shadowMaterials[names[0]] as any).map == undefined)
                (this._partsMaterials.shadowMaterials[names[0]] as any).map = this._partsMaterials.shadowTexes[names[0]];
            this.copyMaterial(this._partsMaterials.shadowMaterials[names[0]], mesh, multiIndex, true);
        }
    }
    private generalShadowMaterial = (materialName: string, mesh: THREE.Mesh, multiIndex: number) => {
        if (this._partsMaterials.shadowMaterials[(webcadDefines.GlobalDefs.GeneralShadowWall as any)] != undefined) {
            if ((this._partsMaterials.shadowMaterials[(webcadDefines.GlobalDefs.GeneralShadowWall as any)] as any).map == undefined)
                (this._partsMaterials.shadowMaterials[(webcadDefines.GlobalDefs.GeneralShadowWall as any)] as any).map = this._partsMaterials.shadowTexes[(webcadDefines.GlobalDefs.GeneralShadowWall as any)];
            this.copyMaterial(this._partsMaterials.shadowMaterials[(webcadDefines.GlobalDefs.GeneralShadowWall as any)], mesh, multiIndex, true);
        }
    }
    // 玄関ドア.
    private entryDoorMaterial = (materialName: string, mesh: THREE.Mesh, multiIndex: number) => {
        if (this._entryDoorMaterial == undefined) {
            const index = this.getMatPrefIndex(materialName, this._partsMaterials.entDoors, 0);
            this._entryDoorMaterial = this._partsMaterials.entDoors[index].clone();
        }
        this.copyMaterial(this._entryDoorMaterial, mesh, multiIndex, true);
    }

    // ドア.
    private doorMaterial = (materialName: string, mesh: THREE.Mesh, multiIndex: number) => {
        if (isMat.bath(materialName)) {
            // 将来,浴室ドア色の切替需要が発生したときは、ドア等の実装に倣う.
            this.copyMaterial((this._partsMaterials as any).bathDoorMateiral, mesh, multiIndex, true);
        }
        else {
            // Conditional : all doors are to have the same material.
            if (this._doorMaterial == undefined) {
                const index = this.getMatPrefIndex(materialName, this._partsMaterials.doorMaterials, 0);
                this._doorMaterial = this._partsMaterials.doorMaterials[index].clone();
            }
            this.copyMaterial(this._doorMaterial, mesh, multiIndex, true);
        }
    }

    // 窓枠.
    private sashBodyMaterial = (materialName: string, mesh: THREE.Mesh, multiIndex: number) => {
        if (this._windowMaterial == undefined) {
            const index = this.getMatPrefIndex(materialName, this._partsMaterials.windowMaterials, 1);
            this._windowMaterial = this._partsMaterials.windowMaterials[index].clone();
        }
        this.copyMaterial(this._windowMaterial, mesh, multiIndex, true);
    }

    // シャッター.
    private garageBody = (materialName: string, mesh: THREE.Mesh, multiIndex: number) => {
        if (this._garageMaterial == undefined) {
            const index = this.getMatPrefIndex(materialName, this._partsMaterials.garageMaterials, 1);
            this._garageMaterial = this._partsMaterials.garageMaterials[index].clone();
        }
        this.copyMaterial(this._garageMaterial, mesh, multiIndex, true);
    }

    // カーテン.
    private curtain = (materialName: string, mesh: THREE.Mesh, multiIndex: number) => {
        if (this._curtainMaterial == undefined) {
            const index = this.getMatPrefIndex(materialName, this._partsMaterials.curtainMaterials, 5);
            this._curtainMaterial = this._partsMaterials.curtainMaterials[index].clone();
        }
        this.copyMaterial(this._curtainMaterial, mesh, multiIndex, true);
    }

    // 畳.
    private tatamiFloor = (materialName: string, mesh: THREE.Mesh, multiIndex: number) => {
        const material = this.getSingleMaterial(mesh, multiIndex);
        material.map = this._partsMaterials.tatamiTexes[0];
    }

    // 床.
    private floor = (materialName: string, mesh: THREE.Mesh, multiIndex: number) => {
        if (this._floorMaterial == undefined) {
            this._floorMaterial = this.getSingleMaterial(mesh, multiIndex);
            const index = this.getTexPrefIndex("interior-floor", this._partsMaterials.floorTexes, 0);
            this._floorMaterial.map = this._partsMaterials.floorTexes[index];
        }
        else {
            this.copyMaterial(this._floorMaterial, mesh, multiIndex, true);
        }
    }

    // 階段.
    private stairs = (materialName: string, mesh: THREE.Mesh, multiIndex: number) => {
        const material = this.getSingleMaterial(mesh, multiIndex);
        if (this._stairMaterial == undefined) {
            const index = this.getTexPrefIndex("rom02-floor", this._partsMaterials.floorTexes, 0);
            const stairIndex: number = this.findTexIndex(this._partsMaterials.stairTexes, this._partsMaterials.floorTexes[index].name + "_STAIR");
            this._stairMaterial = material;
            this._stairMaterial.map = this._partsMaterials.stairTexes[stairIndex];
            this._stairMaterial.color.setRGB(0.5, 0.5, 0.5);
        }
        else {
            this.copyMaterial(this._stairMaterial, mesh, multiIndex, true);
            if (isMat.kekomi(this._stairMaterial.name) && isMat.fumiita(materialName)) {
                this._stairMaterial.color = material.color;
                this._stairMaterial.name = material.name;
            }
        }
    }
    // 下がり壁下面天井.
    private sagari = (materialName: string, mesh: THREE.Mesh, multiIndex: number) => {
        const material = this.getSingleMaterial(mesh, multiIndex);
        if (this._sagariMaterial == undefined) {
            const index = this.getTexPrefIndex('rom02-ceiling'/*mName*/, this._partsMaterials.clothTexes, 0);
            this._sagariMaterial = material;
            this._sagariMaterial.map = this._partsMaterials.clothTexes[index];
            this._sagariMaterial.color.setRGB(2.0, 2.0, 2.0);
        }
        else {
            this.copyMaterial(this._sagariMaterial, mesh, multiIndex, true);
        }
    }
    // 天井.
    private ceiling = (materialName: string, mesh: THREE.Mesh, multiIndex: number) => {
        if (this._ceilingMaterial == undefined) {
            this._ceilingMaterial = this.getSingleMaterial(mesh, multiIndex);
            const index = this.getTexPrefIndex("interior-wall", this._partsMaterials.clothTexes, 0);
            this._ceilingMaterial.map = this._partsMaterials.clothTexes[index];
            this._ceilingMaterial.color.setRGB(1.82, 1.82, 1.82);
        }
        else {
            this.copyMaterial(this._ceilingMaterial, mesh, multiIndex, true);
        }
    }
    // 梁
    private girder = (materialName: string, mesh: THREE.Mesh, multiIndex: number) => {
        if (this._ceilingMaterial == undefined) {
            this._ceilingMaterial = this.getSingleMaterial(mesh, multiIndex);
            const index = this.getTexPrefIndex("interior-wall", this._partsMaterials.clothTexes, 0);
            this._ceilingMaterial.map = this._partsMaterials.clothTexes[index];
            this._ceilingMaterial.color.setRGB(1.82, 1.82, 1.82);
        }
        else {
            this.copyMaterial(this._ceilingMaterial, mesh, multiIndex, true);
        }
    }
    // 断面.
    private section = (materialName: string, mesh: THREE.Mesh, multiIndex: number) => {
        const material = this.getSingleMaterial(mesh, multiIndex);
        material.color = matUtils.getColor(this._partsMaterials.sectionMaterials[0]);
    }
    // 内壁.
    private innerWall = (materialName: string, mesh: THREE.Mesh, multiIndex: number) => {
        if (this._inWallMaterial == undefined) {
            let setName;
            if (isMat.innerWall(materialName)) {
                setName = "interior-wall";
            } else {
                setName = "interior-kosi";
            }
            const index = this.getTexPrefIndex(setName, this._partsMaterials.clothTexes, 0);
            this._inWallMaterial = this.getSingleMaterial(mesh, multiIndex);
            this._inWallMaterial.map = this._partsMaterials.clothTexes[index];
            this._inWallMaterial.color.setRGB(1.62, 1.62, 1.62);
        }
        else {
            this.copyMaterial(this._inWallMaterial, mesh, multiIndex, true);
        }
    }

    // 巾木.
    private habaki = (materialName: string, mesh: THREE.Mesh, multiIndex: number) => {
        if (this._habakiMaterial == undefined) {
            let setName = "interior-habaki";
            let index = this.getTexPrefIndex(setName, this._partsMaterials.habakiTexes, 0);
            this._habakiMaterial = this.getSingleMaterial(mesh, multiIndex);;
            this._habakiMaterial.map = this._partsMaterials.habakiTexes[index];
        }
        else {
            this.copyMaterial(this._habakiMaterial, mesh, multiIndex, true);
        }
    }

    // 屋根.
    private roof = (materialName: string, mesh: THREE.Mesh, multiIndex: number) => {
        const material = this.getSingleMaterial(mesh, multiIndex);
        const floor = WebCadItemManager.getFloor(mesh);
        if (this._roofMaterial[floor] == undefined) {
            const index = this.getTexPrefIndex(materialName, this._partsMaterials.roofTexes, 0);

            material.map = this._partsMaterials.roofTexes[index];

            // this._roofMaterial = this.getSingleMaterial(mesh, multiIndex);
            // this._roofMaterial.map = this._partsMaterials.roofTexes[index];
            this._roofMaterial[floor] = material;
        }
        else {
            this.copyMaterial(this._roofMaterial[floor], mesh, multiIndex, true);
        }
    }

    // 端(hana, nokiura).
    private hana = (materialName: string, mesh: THREE.Mesh, multiIndex: number) => {
        if (this._hanaMaterial == undefined) {
            const index = this.getMatPrefIndex(materialName, this._partsMaterials.hanaMaterials, 0);

            this._hanaMaterial = this.getSingleMaterial(mesh, multiIndex);
            this._hanaMaterial.color = matUtils.getColor(this._partsMaterials.hanaMaterials[index]);
        }
        else {
            const index = this.getMatPrefIndex(materialName, this._partsMaterials.hanaMaterials, 0);
            this.copyMaterial(this._hanaMaterial, mesh, multiIndex, true);
            this._hanaMaterial.color = matUtils.getColor(this._partsMaterials.hanaMaterials[index]);
        }
    }
    // 棟(mune).
    private mune = (materialName: string, mesh: THREE.Mesh, multiIndex: number) => {
        if (this._muneMaterial == undefined) {
            const index = this.getMatPrefIndex(materialName, this._partsMaterials.muneMaterials, 0);

            this._muneMaterial = this.getSingleMaterial(mesh, multiIndex);
            this._muneMaterial.color = matUtils.getColor(this._partsMaterials.muneMaterials[index]);
        }
        else {
            this.copyMaterial(this._muneMaterial, mesh, multiIndex, true);
        }
    }
    // 幕板.
    private makuita = (materialName: string, mesh: THREE.Mesh, multiIndex: number) => {
        if (this._makuitaMaterial == undefined) {
            const index = this.getMatPrefIndex(materialName, this._partsMaterials.makuitaMaterials, 0);

            this._makuitaMaterial = this.getSingleMaterial(mesh, multiIndex);
            this._makuitaMaterial.color = matUtils.getColor(this._partsMaterials.makuitaMaterials[index]);
        }
        else {
            this.copyMaterial(this._makuitaMaterial, mesh, multiIndex, true);
        }
    }
    // 窓枠
    private madowaku = (materialName: string, mesh: THREE.Mesh, multiIndex: number) => {
        if (this._windowMaterial == undefined) {
            const index = this.getMatPrefIndex(materialName, this._partsMaterials.windowMaterials, 1);
            this._windowMaterial = this._partsMaterials.windowMaterials[index].clone();
        }
        this.copyMaterial(this._windowMaterial, mesh, multiIndex, true);
    }
    // ティンバー.
    private timber = (materialName: string, mesh: THREE.Mesh, multiIndex: number) => {
        if (this._timberMaterial == undefined) {
            const index = this.getMatPrefIndex(materialName, this._partsMaterials.timberMaterials, 0);

            this._timberMaterial = this.getSingleMaterial(mesh, multiIndex);
            this._timberMaterial.color = matUtils.getColor(this._partsMaterials.timberMaterials[index]);
        }
        else {
            this.copyMaterial(this._timberMaterial, mesh, multiIndex, true);
        }
    }
    // 笠木
    private kasagi = (materialName: string, mesh: THREE.Mesh, multiIndex: number) => {
        const material = this.getSingleMaterial(mesh, multiIndex);
        material.color = matUtils.getColor((this._partsMaterials as any).kasagiMaterials[0]);
    }
    // 外壁.
    private outerWall = (materialName: string, mesh: THREE.Mesh, multiIndex: number) => {
        const material = this.getSingleMaterial(mesh, multiIndex);
        const floor = WebCadItemManager.getFloor(mesh);
        if (this._wallMaterials[floor] == undefined) {
            const index = this.getTexPrefIndex(materialName, this._partsMaterials.wallTexes, 0);
            material.map = this._partsMaterials.wallTexes[index];// = wallMaterial;
            material.color.setRGB(1.2, 1.2, 1.2);
            this._wallMaterials[floor] = material;
        }
        else {
            this.copyMaterial(this._wallMaterials[floor], mesh, multiIndex, true);
        }
    }
    // 外壁（腰）
    private outerWallKosi = (materialName: string, mesh: THREE.Mesh, multiIndex: number) => {
        const material = this.getSingleMaterial(mesh, multiIndex);
        const floor = isMat.kosiFloorFromMatName(materialName);
        if (this._wallKosiMaterials[floor] == undefined) {
            const index = this.getTexPrefIndex(materialName, this._partsMaterials.wallKosiTexes, 0);
            material.map = this._partsMaterials.wallKosiTexes[index];
            material.color.setRGB(1.2, 1.2, 1.2);
            this._wallKosiMaterials[floor] = material;
        }
        else {
            this.copyMaterial(this._wallKosiMaterials[floor], mesh, multiIndex, true);
        }
    }
    // 水切り
    private mizukiri = (materialName: string, mesh: THREE.Mesh, multiIndex: number) => {
        const material = this.getSingleMaterial(mesh, multiIndex);
        material.color.setRGB(0.25, 0.25, 0.25);
    }

    // 妻.
    private tuma = (materialName: string, mesh: THREE.Mesh, multiIndex: number) => {
        const material = this.getSingleMaterial(mesh, multiIndex);
        const floor = WebCadItemManager.getFloor(mesh);
        const altName = materialName.replace(/tuma/g, "wall");
        if (this._wallMaterials[floor] == undefined) {
            let index = this.getTexPrefIndex(altName, this._partsMaterials.wallTexes, -1);
            material.map = this._partsMaterials.wallTexes[index];// = wallMaterial;
            material.color.setRGB(1.2, 1.2, 1.2);
            this._wallMaterials[floor] = material;
        }
        else {
            this.copyMaterial(this._wallMaterials[floor], mesh, multiIndex, true);
        }
    }
    // バルコニー.
    private balcony = (materialName: string, mesh: THREE.Mesh, multiIndex: number) => {
        const material = this.getSingleMaterial(mesh, multiIndex);
        const floor = WebCadItemManager.getFloor(mesh);
        if (this._wallKosiMaterials[floor] == undefined) {
            let index = this.getTexPrefIndex(materialName, this._partsMaterials.wallKosiTexes, 0);
            material.map = this._partsMaterials.wallKosiTexes[index];
            material.color.setRGB(1.2, 1.2, 1.2);
            this._wallKosiMaterials[floor] = material;
        }
        else {
            this.copyMaterial(this._wallKosiMaterials[floor], mesh, multiIndex, true);
        }
    }
    // 玄関床.
    private entrance = (materialName: string, mesh: THREE.Mesh, multiIndex: number) => {
        const material = this.getSingleMaterial(mesh, multiIndex);
        this.copyMaterial(this._partsMaterials.entrance, mesh, multiIndex, true);
        const index = this.getTexPrefIndex(materialName, this._partsMaterials.entranceTexes, 0);
        material.map = this._partsMaterials.entranceTexes[index];
    }
    // ポーチ.
    private porch = (materialName: string, mesh: THREE.Mesh, multiIndex: number) => {
        const material = this.getSingleMaterial(mesh, multiIndex);
        this.copyMaterial(this._partsMaterials.porch, mesh, multiIndex, true);
        const index = this.getTexPrefIndex(materialName, this._partsMaterials.porchTexes, 0);
        material.map = this._partsMaterials.porchTexes[index];
    }
    // ベース.
    private base = (materialName: string, mesh: THREE.Mesh, multiIndex: number) => {
        this.copyMaterial(this._partsMaterials.baseMaterials[0], mesh, multiIndex, true);
        const index = this.getTexPrefIndex(materialName, this._partsMaterials.baseTexes, 0);
        const material = this.getSingleMaterial(mesh, multiIndex);
        material.map = this._partsMaterials.baseTexes[index];
    }
    // 敷地.
    private site = (materialName: string, mesh: THREE.Mesh, multiIndex: number) => {
        this.copyMaterial(this._partsMaterials.siteMaterials[0], mesh, multiIndex, true);
    }
    // 目地.
    private meji = (materialName: string, mesh: THREE.Mesh, multiIndex: number) => {
        this.copyMaterial(this._partsMaterials.mejiMaterials[0], mesh, multiIndex, true);
    }
    // 斜線規制.
    private setback = (materialName: string, mesh: THREE.Mesh, multiIndex: number) => {
        this.copyMaterial(this._partsMaterials.setbackMaterials[0], mesh, multiIndex, true);
    }
    // ライン(道路より先に置く).
    private line = (materialName: string, mesh: THREE.Mesh, multiIndex: number) => {
        this.copyMaterial(this._partsMaterials.lineMaterials[0], mesh, multiIndex, true);
    }
    // 道路.
    private road = (materialName: string, mesh: THREE.Mesh, multiIndex: number) => {
        this.copyMaterial(this._partsMaterials.roadMaterials[0], mesh, multiIndex, true);
    }

    /* processMaterial
     * Materialの設定.
     */
    private processMaterial(mesh: THREE.Mesh, multiIndex: number): boolean {
        if (this._partsMaterials == undefined) return false;

        const material = this.getSingleMaterial(mesh, multiIndex);
        let material_name = material.name;
        if (material_name === "") material_name = mesh.name;
        const mName = this.replaceName(material_name);

        const funcs: any[][] = [
            [isMat.glass, this.glassMaterial],                  // ガラス.
            [isMat.metal,this.metalMaterial],                   // 金物.
            [isMat.wallShadow, this.wallShadowMaterial],        // 壁影.
            [isMat.generalShadow, this.generalShadowMaterial],  // 壁影.
            [isMat.entryDoor, this.entryDoorMaterial],          // 玄関ドア.
            [isMat.door, this.doorMaterial],
            [isMat.sashBody, this.sashBodyMaterial],
            [isMat.garageBody, this.garageBody],
            [isMat.curtain, this.curtain],
            [isMat.tatamiFloor, this.tatamiFloor],
            [isMat.floor, this.floor],
            [isMat.stairs, this.stairs],
            [isMat.sagari, this.sagari],
            [isMat.ceiling, this.ceiling],
            [isMat.girder, this.girder],                        // 梁
            [isMat.section, this.section],
            [isMat.innerWall, this.innerWall],
            [isMat.column, this.innerWall],                 // 柱
            [isMat.habaki, this.habaki],
            [isMat.roof, this.roof],
            [isMat.hana, this.hana],
            [isMat.mune, this.mune],
            [isMat.makuita, this.makuita],
            [isMat.madowaku, this.madowaku],
            [isMat.timber, this.timber],
            [isMat.kasagi, this.kasagi],
            [isMat.balcony, this.balcony],
            [isMat.outerWall, this.outerWall],
            [isMat.outerWallKosi, this.outerWallKosi],
            [isMat.mizukiri, this.mizukiri],
            [isMat.tuma, this.tuma],
            [isMat.entrance, this.entrance],
            [isMat.porch, this.porch],
            [isMat.base, this.base],
            [isMat.site, this.site],
            [isMat.meji, this.meji],
            [isMat.setback, this.setback],
            [isMat.line, this.line],
            [isMat.road, this.road]
        ];
        for(let i = 0; i < funcs.length; i++) {
            const func = funcs[i];
            const result = func[0](mName);
            if (result) {
                func[1](mName, mesh, multiIndex);
                return true;
            }
        }
        return false;
    }

    private replaceName(material_name: string): string {
        return material_name.replace(/-[0-9]+/g, "").replace('-node', "");
    }

    /* adjustMultiMat
     * 家具/備品にマテリアルを適用する.
     */
    private adjustMultiMat(mats: THREE.Material[], i: number, whiteModel?: boolean): void {
        mats[i].alphaTest = 0.5;

        if (whiteModel == undefined) whiteModel = false;
        if (mats[i].name.match(/glass/) && (matUtils.getImageMap(mats[i]) == undefined)) {
            mats[i] = matUtils.getMaterialFromName(this._partsMaterials.glassMaterials, mats[i].name);
        }
        else if (mats[i].name == "metal") {
            mats[i] = whiteModel ? this._partsMaterials.metal_wm : this._partsMaterials.metal;
        }
        else if (mats[i].name == "mirror") {
            mats[i] = whiteModel ? this._partsMaterials.mirror_wm : this._partsMaterials.mirror;
        }
        else if (mats[i].name == "cloth") {
            mats[i] = whiteModel ? this._partsMaterials.tableCloth_wm : this._partsMaterials.tableCloth;
            matUtils.setImageMap(mats[i], this._partsMaterials.tableClothTex);
        }
        else if ((mats[i].name == "ceramic") || (mats[i].name == "white90")) {
            mats[i] = whiteModel ? this._partsMaterials.ceramic_wm : this._partsMaterials.ceramic;
        }
        else if (mats[i].name == "newspaper") {
            mats[i] = this._partsMaterials.newspaper;
        }
        else if (mats[i].name == "screen") {
            mats[i] = whiteModel ? this._partsMaterials.screen_wm : this._partsMaterials.screen;
        }

        if (mats[i].name == "leaves") {
            mats[i].transparent = true;
        }
    }

    /* adjustMat
     * 家具/備品にマテリアルを適用する.
     */
    private adjustMat(mat: THREE.Material, whiteModel?: boolean): void {
        mat.alphaTest = 0.5;

        if (whiteModel == undefined) whiteModel = false;
        if (mat.name.match(/glass/) && (matUtils.getImageMap(mat) == undefined)) {
            mat = matUtils.getMaterialFromName(this._partsMaterials.glassMaterials, mat.name);
        }
        else if (mat.name == "metal") {
            mat = whiteModel ? this._partsMaterials.metal_wm : this._partsMaterials.metal;
        }
        else if (mat.name == "mirror") {
            mat = whiteModel ? this._partsMaterials.mirror_wm : this._partsMaterials.mirror;
        }
        else if (mat.name == "cloth") {
            mat = whiteModel ? this._partsMaterials.tableCloth_wm : this._partsMaterials.tableCloth;
            matUtils.setImageMap(mat, this._partsMaterials.tableClothTex);
        }
        else if ((mat.name == "ceramic") || (mat.name == "white90")) {
            mat = whiteModel ? this._partsMaterials.ceramic_wm : this._partsMaterials.ceramic;
        }
        else if (mat.name == "newspaper") {
            mat = this._partsMaterials.newspaper;
        }
        else if (mat.name == "screen") {
            mat = whiteModel ? this._partsMaterials.screen_wm : this._partsMaterials.screen;
        }

        if (mat.name == "leaves") {
            mat.transparent = true;
        }
    }
    /* adjustMaterial
     * 家具/備品にマテリアルを適用する.
     */
    public adjustMaterial(item: THREE.Object3D, whiteModel?: boolean): void {
        if (whiteModel == undefined) whiteModel = false;
        const mesh: THREE.Mesh = <THREE.Mesh>(item);
        if (mesh.isMesh) {
            if (mesh.material != undefined) {
                if (Array.isArray(mesh.material)) {
                    const multiMat = mesh.material;
                    for (let i = 0; i < multiMat.length; i++) {
                        this.adjustMultiMat(multiMat, i, whiteModel);
                    }
                } else {
                    this.adjustMat(mesh.material, whiteModel);
                }
            }
        }
        else if (item.children != undefined) {
            for (let i = 0; i < item.children.length; i++) {
                this.adjustMaterial(item.children[i], whiteModel);
            }
        }
    }

    /* isWhiteModel
     * ホワイトモデルか.
     */
    public isWhiteModel(item: any): boolean {
        if (item.url == undefined) return false;
        return item.url.match(/(fur|equ)(\d{2}_\d{2})(\.dae)/) != null;
    }

    /* adjustMaterials
     * 家具/備品にマテリアルを適用する.
     */
    public adjustMaterials(items: THREE.Group[]) {
        for (let i = 0; i < items.length; i++) {
            this.adjustMaterial(items[i], this.isWhiteModel(items[i]));
        }
    }

    /* currentTexture
     * 現在の選択テクスチャ名を返す.
     */
    public currentTexture(type: ItemType, floor?: number): string {
        if (floor == undefined) floor = 1;
        const model = ThreeView.get().planmgr.autoData.Model;
        switch (type) {
            case ItemType.Floor: return model.Interior.GetMaterialName('floor');
            case ItemType.Cloth: return model.Interior.GetMaterialName('wall');
            case ItemType.Roof: return model.getOutMaterial(floor).GetMaterialName('roof');
            case ItemType.Wall: return model.getOutMaterial(floor).GetMaterialName('wall');
            case ItemType.WallKosi: return model.getOutMaterial(floor).GetMaterialName('kosi');
            case ItemType.Habaki: return model.Interior.GetMaterialName('habaki');

            // case ItemType.Roof: return eval("model.Out0" + floor ).GetMaterialName('roof');
            // case ItemType.Wall: return eval("model.Out0" + floor ).GetMaterialName('wall');
            // case ItemType.WallKosi: return eval("model.Out0" + floor ).GetMaterialName('kosi');
        }
        return "";
    }

    /* currentMaterial
     * 現在の選択マテリアル名を返す.
     */
    public currentMaterial(type: ItemType): string {
        const model = ThreeView.get().planmgr.autoData.Model;
        switch (type) {
            case ItemType.Entry: return model.Ent.GetMaterialName('body');
            case ItemType.Door: return model.Door.GetMaterialName('body');
            case ItemType.Sash: return model.Sash.GetMaterialName('body');
            case ItemType.Curtain: return model.Sash.GetMaterialName('curtain');
            case ItemType.Garage: return model.Shutter.GetMaterialName('body');
        }
        return "";
    }

    /* getAlternativeList
     * 入替用のマテリアルリストを返す.
     */
    public getAlternativeList(type: ItemType, floor?: number): w3dItemInfo[] {
        const itemList: w3dItemInfo[] = [];
        if (this._partsMaterials != undefined) {
            let textures: THREE.Texture[] = undefined;
            let materials: Material[] = undefined;
            if (
                ((type == ItemType.Floor) && (textures = this._partsMaterials.floorTexes)) ||
                ((type == ItemType.Habaki) && (textures = this._partsMaterials.habakiTexes)) ||
                ((type == ItemType.Cloth) && (textures = this._partsMaterials.clothTexes)) ||
                ((type == ItemType.Roof) && (textures = this._partsMaterials.roofTexes)) ||
                ((type == ItemType.Wall) && (textures = this._partsMaterials.wallTexes)) ||
                ((type == ItemType.WallKosi) && (textures = this._partsMaterials.wallKosiTexes))) {
                const currentTex = this.currentTexture(type, floor);
                for (let i = 0; i < textures.length; i++) {
                    const tex = textures[i];
                    itemList.push(new w3dItemInfo({ name: tex.userData.title, url: tex.userData.url, selected: (currentTex == tex.name),thumbnail:tex.userData.thumbnail, category: tex.userData.category }));
                }
            }
            else if (
                ((type == ItemType.Entry) && (materials = this._partsMaterials.entDoors)) ||
                ((type == ItemType.Door) && (materials = this._partsMaterials.doorMaterials)) ||
                ((type == ItemType.Sash) && (materials = this._partsMaterials.windowMaterials)) ||
                ((type == ItemType.Curtain) && (materials = this._partsMaterials.curtainMaterials)) ||
                ((type == ItemType.Garage) && (materials = this._partsMaterials.garageMaterials))) {
                const currentMat = this.currentMaterial(type);
                for (let i = 0; i < materials.length; i++) {
                    const mat = materials[i];
                    const color: string = matUtils.getColorString(mat);
                    itemList.push(new w3dItemInfo({ name: mat.title, color: color, selected: (currentMat == mat.name) }));
                }
            }
        }
        return itemList;
    }
        
    /* findTexIndex
     * 名前からテクスチャインデックスを得る.
     */
    public findTexIndex(textures: any[], name: string, def?: number): number {
        if (def == undefined) def = 0;
        for (let i = 0; i < textures.length; i++) {
            if (textures[i].name == name) return i;
        }
        return def;
    }

    // /* changeColor
    //  * マテリアルを変更する.
    //  */
    // public changeColor(type: ItemType, index: number, floor?: number): void {
    //     const model = ThreeView.get().planmgr.autoData.Model;
    //     const materialSet = this._partsMaterials;
    //     switch (type) {
    //         case ItemType.Entry:
    //             // Conditional : all doors are to have the same material.
    //             this.changeMaterialUnified(this._entryDoorMaterial, materialSet.entDoors, index);
    //             model.Ent.SetMaterialName('body', materialSet.entDoors[index].name);

    //             //pixelstreaming対応
    //             this.changePrefs('ent-body', materialSet.entDoors[index].name);
    //             break;
    //         case ItemType.Door:
    //             // Conditional : all doors are to have the same material.
    //             this.changeMaterialUnified(this._doorMaterial, materialSet.doorMaterials, index);
    //             model.Door.SetMaterialName('body', materialSet.doorMaterials[index].name);

    //             //pixelstreaming対応
    //             this.changePrefs('door-body', materialSet.doorMaterials[index].name);
    //             break;
    //         case ItemType.Sash:
    //             // Conditional : all doors are to have the same material.
    //             this.changeMaterialUnified(this._windowMaterial, materialSet.windowMaterials, index);
    //             model.Sash.SetMaterialName('body', materialSet.windowMaterials[index].name);

    //             //pixelstreaming対応
    //             this.changePrefs('sash-body', materialSet.windowMaterials[index].name);
    //             break;
    //         case ItemType.Garage:
    //             // Conditional : all doors are to have the same material.
    //             this.changeMaterialUnified(this._garageMaterial, materialSet.garageMaterials, index);
    //             model.Shutter.SetMaterialName('body', materialSet.garageMaterials[index].name);

    //             //pixelstreaming対応
    //             this.changePrefs('shutter-body', materialSet.windowMaterials[index].name);                
    //             break;
    //         case ItemType.Curtain:
    //             // Conditional : all doors are to have the same material.
    //             this.changeMaterialUnified(this._curtainMaterial, materialSet.curtainMaterials, index);
    //             model.Sash.SetMaterialName('curtain', materialSet.curtainMaterials[index].name);
    //             break;
    //         // 床・階段.
    //         case ItemType.Floor:
    //             // Conditional : all doors are to have the same material.
    //             const floorTexture = materialSet.floorTexes[index];
    //             this.changeMapUnified(this._floorMaterial, floorTexture);
    //             const stairIndex = this.findTexIndex(materialSet.stairTexes, floorTexture.name + "_STAIR");
    //             this.changeMapUnified(this._stairMaterial, materialSet.stairTexes[stairIndex]);
    //             model.SetMaterialName("interior", "floor", floorTexture.name);

    //             //pixelstreaming対応
    //             this.changeMaterial(this._floorMaterial, floorTexture.name);    // 床
    //             this.changePrefs('interior-floor', floorTexture.name);          // 床
    //             this.changeMaterial(this._stairMaterial, materialSet.stairTexes[stairIndex].name);    // 階段
    //             break;
    //         // 内壁.
    //         case ItemType.Cloth:
    //             // Conditional : all doors are to have the same material.
    //             const cloth = materialSet.clothTexes[index];
    //             this.changeMapUnified(this._inWallMaterial, cloth);
    //             this.changeMapUnified(this._ceilingMaterial, cloth);
    //             this.changeMapUnified(this._sagariMaterial, cloth);
    //             model.SetMaterialName("interior", "wall", cloth.name);
    //             model.SetMaterialName("interior", "kosi", cloth.name);
    //             model.SetMaterialName("interior", "ceiling", cloth.name);

    //             //pixelstreaming対応
    //             this.changeMaterial(this._inWallMaterial, cloth.name);
    //             this.changeMaterial(this._ceilingMaterial, cloth.name);
    //             this.changeMaterial(this._sagariMaterial, cloth.name);
    //             this.changePrefs('interior-wall', cloth.name);
    //             this.changePrefs('interior-kosi', cloth.name);
    //             this.changePrefs('interior-ceiling', cloth.name);
    //             break;
    //         // 屋根、端、棟.
    //         case ItemType.Roof:
    //             const roofTexture = materialSet.roofTexes[index];

    //             const hanaIndex = this.findMatIndex(materialSet.hanaMaterials, roofTexture.name + "_HANA");
    //             const muneIndex = this.findMatIndex(materialSet.muneMaterials, roofTexture.name + "_MUNE");

    //             const hanaTExture = materialSet.hanaMaterials[hanaIndex];
    //             const muneTexture = materialSet.muneMaterials[muneIndex];

    //             this.changeMaterialUnified(this._hanaMaterial, materialSet.hanaMaterials, hanaIndex);
    //             this.changeMaterialUnified(this._muneMaterial, materialSet.muneMaterials, muneIndex);
    //             for (let floor = 1; floor <= webcadDefines.Limits.maxFloor; floor++) {
    //                 this.changeMapUnified(this._roofMaterial[floor], roofTexture);
    //                 this.setOutMatChange("roof", roofTexture.name, floor);
    //                 this.setOutMatChange("hana", materialSet.hanaMaterials[hanaIndex].name, floor);
    //                 this.setOutMatChange("mune", materialSet.muneMaterials[muneIndex].name, floor);

    //                 //pixelstreaming対応
    //                 this.changeMaterial(this._roofMaterial[floor], roofTexture.name);
    //             }
    //             //pixelstreaming対応

    //             this.changeMaterial(this._hanaMaterial, hanaTExture.name);
    //             this.changeMaterial(this._muneMaterial, muneTexture.name);
    //             break;
    //         // 外壁.
    //         case ItemType.Wall:
    //             const wallTexture = materialSet.wallTexes[index];
    //             this.changeMapUnified(this._wallMaterials[floor], wallTexture);
    //             this.setOutMatChange("wall", wallTexture.name, floor);

    //             //pixelstreaming対応
    //             this.changeMaterial(this._wallMaterials[floor], wallTexture.name);
    //             break;
    //         // 外壁腰.
    //         case ItemType.WallKosi:
    //             const wallKosiTexture = materialSet.wallKosiTexes[index];
    //             this.changeMapUnified(this._wallKosiMaterials[floor], wallKosiTexture);
    //             this.setOutMatChange("kosi", wallKosiTexture.name, floor);
    //             this.setOutMatChange("balcony", wallKosiTexture.name, floor);

    //             //pixelstreaming対応
    //             this.changeMaterial(this._wallKosiMaterials[floor], wallKosiTexture.name);
    //             break;
    //         // 巾木.
    //         case ItemType.Habaki:
    //             // Conditional : all doors are to have the same material.
    //             const habakiTexture = materialSet.habakiTexes[index];
    //             this.changeMapUnified(this._habakiMaterial, habakiTexture);
    //             model.SetMaterialName("interior", "habaki", habakiTexture.name);

    //             //pixelstreaming対応
    //             this.changePrefs('interior-habaki', habakiTexture.name);
    //             break;
    //     }

    //     //2D側に変更結果を反映
    //     let jsonData = model.writeJSON();
    //     marietta.webcad.WebCADGlobal.setModelParamFromConstructionModel(jsonData);
    // }

    /* lightPref
     * Materialの設定を取得.
     */
    public get materialInited(): boolean {
        return (this._partsMaterials != undefined);
    }

    public lightPref(name: string): {} {
        return (this._partsMaterials as any).lightSettings['lig:' + name];
    }
    // adjustForRendering
    public adjustForRendering(renderer: WebCadRenderer) {
        if (this._ceilingMaterial) this._ceilingMaterial.color.setRGB(1.82, 1.82, 1.82);
        if (this._sagariMaterial) this._sagariMaterial.color.setRGB(2.0, 2.0, 2.0);
    }

}
